import { render, staticRenderFns } from "./delete-customer-modal.vue?vue&type=template&id=601eff40&lang=pug"
import script from "./delete-customer-modal.vue?vue&type=script&lang=js"
export * from "./delete-customer-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports